import cn from 'classnames';

import { PriceLevel } from '../../hooks/usePriceLevels';
import styles from './PriceLevelDisplay.module.css';

interface PriceLevelDisplayProps {
    priceLevel: PriceLevel | undefined;
    className?: string;
}

export const PriceLevelDisplay = ({ priceLevel, className }: PriceLevelDisplayProps) => {
    const priceMap = {
        [PriceLevel.GREEN]: '$',
        [PriceLevel.YELLOW]: '$$',
        [PriceLevel.RED]: '$$$',
    };

    const displayValue = priceMap[priceLevel as PriceLevel] || '';

    const ariaLabel = {
        [PriceLevel.GREEN]: 'Laveste prisnivå',
        [PriceLevel.YELLOW]: 'Medium prisnivå',
        [PriceLevel.RED]: 'Dyreste prisnivå',
    };

    return (
        <span
            title={ariaLabel[priceLevel as PriceLevel]}
            className={cn(styles.priceLevelDisplay, { [styles.priceLevelDisplayDefault]: !displayValue }, className)}>
            <span aria-hidden="true">{displayValue}</span>
            <span className="sr-only">{ariaLabel[priceLevel as PriceLevel]}</span>
        </span>
    );
};
